export default __webpack_public_path__ + "static/media/DOPPLE-DOP-LP.7241cf18.svg";